import * as R from 'ramda'
import { useRef, useState } from 'react'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Material
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
// components
import { MyAccountBackground } from '$common/my-account-background'
import { getClientUser, updateClientUser } from '$logic/client-user'
import { editProfile, getProfile } from '$logic/profile/service'
import { closeEditAccount } from '$logic/router'
import { showDiscardChangesConfirmModal } from '$comp/modals/confirmation-dialog'
import { areEqualStr } from '$func/text'
import { showSaveChangesLoadingModal } from '$comp/modals/loading-modal'
import { EditAccountAppBar } from './edit-account-app-bar'
import { EditAccountProfileBoxApiType } from './edit-account-profile-box'
import {
  EditAccountContentBox,
  EditAccountContentBoxApiType,
} from './edit-account-content-box'

const Root = styled(Box)(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.veryVeryLightGray,
  position: 'relative',
  overflowY: 'auto',
}))

// TODO: Refactor this component
export function EditAccount() {
  const imageRef = useRef<EditAccountProfileBoxApiType>(null)
  const profileRef = useRef<EditAccountContentBoxApiType>(null)

  const [firstNameIsEmpty, setFirstNameIsEmpty] = useState<boolean>(false)

  const getChangedFields = () => {
    const user = getClientUser()
    const profile = getProfile()
    const image = imageRef.current
    if (!image || !profileRef.current)
      return { userChangesField: {}, profileChangedFields: {} }

    const userChangesField = {
      ...(!areEqualStr(imageRef.current.get(), user.image || '') && {
        image: imageRef.current.get(),
      }),
      ...(!areEqualStr(profileRef.current.getFirstname(), user.firstname) && {
        firstname: profileRef.current.getFirstname(),
      }),
      ...(!areEqualStr(
        profileRef.current.getLastname(),
        user.lastname || '',
      ) && {
        lastname: profileRef.current.getLastname(),
      }),
    }

    const newLocation = profileRef.current.getLocation()

    const profileChangedFields = {
      ...(!areEqualStr(
        profileRef.current.getBirthDate(),
        profile.birthDate,
      ) && {
        birthDate: profileRef.current.getBirthDate(),
      }),
      ...(!areEqualStr(profileRef.current.getGender(), profile.gender) && {
        gender: profileRef.current.getGender(),
      }),
      ...((newLocation?.county !== profile.location?.county ||
        newLocation?.province !== profile.location?.province) && {
        location: profileRef.current.getLocation(),
      }),
    }

    return { userChangesField, profileChangedFields }
  }

  const onSave = async () => {
    const { userChangesField, profileChangedFields } = getChangedFields()

    setFirstNameIsEmpty(false)
    if ('firstname' in userChangesField && !userChangesField.firstname) {
      setFirstNameIsEmpty(true)
      return
    }
    // TODO: Verify props

    const requests: Promise<unknown>[] = []

    if (!R.isEmpty(userChangesField))
      requests.push(updateClientUser(userChangesField))
    if (!R.isEmpty(profileChangedFields))
      requests.push(editProfile(profileChangedFields))

    if (requests.length) {
      showSaveChangesLoadingModal()
      await Promise.all(requests)
      await closeCurrentModal()
      analite('PROFILE_EDIT_INFO')
    }

    await closeEditAccount()
  }

  const onBack = () => {
    const { userChangesField, profileChangedFields } = getChangedFields()
    if (R.isEmpty(userChangesField) && R.isEmpty(profileChangedFields))
      closeEditAccount()
    else showDiscardChangesConfirmModal(closeEditAccount, onSave)
  }

  return (
    <Root>
      <MyAccountBackground />
      <EditAccountAppBar onSave={onSave} onBack={onBack} />
      <EditAccountContentBox
        ref={imageRef}
        forwardedRef={profileRef}
        firstNameIsEmpty={firstNameIsEmpty}
      />
    </Root>
  )
}
